import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
import { utc } from 'moment';
import { isArray } from 'util';

@Pipe({ name: 'ngxExcelDateTime' })
export class NgxExcelDateTimePipe implements PipeTransform {

  /**
   * æ ¼å¼åæ¾ç¤ºæ¥æ
   * @param value æ¥æå­ç¬¦ä¸²
   * @param format æ ¼å¼ date / time / datetime
   */
  transform(value: string | Date | Date[], format?: string): any {
    let inputValues = [] as Array<string | Date>;
    if (typeof (value) === 'string' && value.indexOf(',') >= 0) {
      inputValues = value.split(',');
    } else if (isArray(value)) {
      inputValues = [...(value as Date[])];
    }
    if (inputValues.length >= 2) {
      let stringBegin = '';
      let stringEnd = '';
      let formatedString = '';
      switch (format) {
        case 'time':
          try { stringBegin = this.transformTime(inputValues[0]); } catch (_) { stringBegin = ''; }
          try { stringEnd = this.transformTime(inputValues[1]); } catch (_) { stringEnd = ''; }
          break;
        case 'date':
          try { stringBegin = this.transformDate(inputValues[0]); } catch (_) { stringBegin = ''; }
          try { stringEnd = this.transformDate(inputValues[1]); } catch (_) { stringEnd = ''; }
          break;
        default:
          try { stringBegin = this.transformDateTime(inputValues[0]); } catch (_) { stringBegin = ''; }
          try { stringEnd = this.transformDateTime(inputValues[1]); } catch (_) { stringEnd = ''; }
      }
      if (stringBegin.length === 0 && stringEnd.length === 0) {
        formatedString = 'æ ¼å¼éè¯¯';
      } else {
        stringBegin = stringBegin || 'ä¸é';
        stringEnd = stringEnd || 'ä¸é';
        formatedString = `${stringBegin} ~ ${stringEnd}`;
      }
      return formatedString;
    } else {
      let formatedString = '';
      switch (format) {
        case 'time':
          try { formatedString = this.transformTime(value as string | Date); } catch (_) { formatedString = ''; }
          break;
        case 'date':
          try { formatedString = this.transformDate(value as string | Date); } catch (_) { formatedString = ''; }
          break;
        default:
          try { formatedString = this.transformDateTime(value as string | Date); } catch (_) { formatedString = ''; }
      }
      return formatedString.length === 0 ? 'æ ¼å¼éè¯¯' : formatedString;
    }
  }

  protected transformTime(value: string | Date) {
    if (!value) { return ''; }
    if (typeof (value) === 'string') {
      const timeObj = utc(`${value} +0800`, 'HH:mm Z', true);
      value = timeObj.isValid() ? timeObj.toDate() : null;
    }
    return formatDate(value, 'HH:mm', 'zh');
  }

  protected transformDate(value: string | Date) {
    if (!value) { return ''; }
    if (typeof (value) === 'string') {
      const dateObj = utc(`${value} +0800`, 'YYYY-MM-DD Z', true);
      value = dateObj.isValid() ? dateObj.toDate() : null;
    }
    return formatDate(value, 'yyyy-MM-dd', 'zh');
  }

  protected transformDateTime(value: string | Date) {
    if (!value) { return ''; }
    if (typeof (value) === 'string') {
      const datetimeObj = utc(`${value} +0800`, 'YYYY-MM-DD HH:mm Z', true);
      value = datetimeObj.isValid() ? datetimeObj.toDate() : null;
    }
    return formatDate(value, 'yyyy-MM-dd HH:mm', 'zh');
  }
}
